module.exports = __webpack_public_path__ + "img/BMW_i_White-Colour_RGB.3272eda6.png";